type NonNullableKeys<T> = {
    [K in keyof T]-?: Exclude<T[K], null>;
};

export function hasNonNullKeys<T extends object>(obj: T): obj is NonNullableKeys<T> {
    return Object.values(obj).every(value => value !== null);
}
